import { render } from "./barchart.vue?vue&type=template&id=708e5ca3"
import script from "./barchart.vue?vue&type=script&lang=js"
export * from "./barchart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__